// @flow

/* Libs */
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

/* Stores */
import useFurnituresCategoriesStore from 'Stores/FurnituresCategories';

const CategoriesFurnitures = () => {
	const categories = useFurnituresCategoriesStore(state => state.categories);
	const fetchCategories = useFurnituresCategoriesStore(state => state.fetchCategories);

	useEffect(() => {
		if (!categories) {
			fetchCategories();
		} else {
			console.log('categories are setted', categories);
		}
	}, [categories]);


	return (
		<div className="App-Furnitures-listing">
			<h3>Liste des catégories</h3>

			<div className="furnitures-list">
				{ !categories && <p>Chargement...</p> }
				{ categories && categories.length === 0 && <p>Pas de catégories, en rajouter une ? </p> }
				{ categories && categories.length > 0 && categories.map(category => (
					<Link
						to={`/inventory/furnitures/${category.id}`}
						className="furnitures-item categories"
						key={category.id}
					>
						{ category.name }
					</Link>
				)) }
			</div>
		</div>
	);
};

export default CategoriesFurnitures;
